(function() {
  'use strict';

  angular.module('ringbaPortal')
    .controller('TargetsDashboardController', TargetsDashboardController);

  function TargetsDashboardController(
    _,
    $scope,
    $interval,
    $timeout,
    $log,
    $state,
    orderByFilter,
    accountsService,
    userSettingsService,
    targetService,
    columnsFetchService
  ) {
    'ngInject';

    const vm = this;
    let timer;

    vm.userSettings = {};
    vm.isLoading = true;
    vm.currentAccountId = accountsService.currentAccountId;
    vm.defaultColumns = [
      'name',
      'currentLive',
      'currentHour',
      'status'
    ];

    vm.columnSettings = {
      name: {
        class: 'tablesort-sortable width-40-percent',
        stSort: 'name',
        displayName: 'TARGETS_NAME'
      },
      currentLive: {
        class: 'tablesort-sortable p-r-0 p-l-15',
        stSort: 'usageStats.currentLive',
        displayName: 'STATS_LIVE',
        rowAlign: 'left'
      },
      currentHour: {
        class: 'tablesort-sortable p-r-0 p-l-15',
        stSort: 'usageStats.currentHour',
        displayName: 'STATS_HOUR',
        rowAlign: 'left'
      },
      status: {
        class: 'tablesort-sortable',
        stSort: 'tStatus.uiStatus.status',
        displayName: 'STATUS_TEXT',
        rowAlign: 'center'
      }
    };

    vm.$onInit = onInit;
    vm.viewTarget = viewTarget;
    vm.dropSuccess = dropSuccess;

    function onInit() {
      _loadUserSettings().then(function () {
        return _loadCurrentTargets();
      });

      timer = $interval(function () {
        targetService.getTargets(vm.currentAccountId, true, { targets: vm.currentTargets }).then(function () {
          $scope.$broadcast('refreshTargets');
        });
      }, 15000);
    }

    function dropSuccess (e, item, collection){
      // collection contains the current ordering of columns
      // after the drag and drop. We need to save the
      // collection in user settings under dashboardTargets key
      userSettingsService.getUserSettings()
        .then(function (userSettings){
          vm.userSettings = userSettings;
          if (!vm.userSettings.dashboardTargets) {
            vm.userSettings.dashboardTargets = {};
          }
          vm.userSettings.dashboardTargets.columns = collection;
          return userSettingsService.saveUserSettings(vm.userSettings);
        });
    }

    function viewTarget(targetId) {
      $state.go('dashboard.target.edit', {
        targetId: targetId
      });
    }

    function _loadCurrentTargets() {
      targetService.getTargets(vm.currentAccountId, true)
        .then(function (targets) {
          const temp = _.filter(targets, function (t) {
            return t.usageStats ? (t.usageStats.currentLive > 0 || t.usageStats.currentHour > 0 || t.usageStats.currentDay > 0 || t.usageStats.currentMonth > 0) : false;
          });
          vm.currentTargets = _.cloneDeep(temp);
          vm.isLoading = false;

          // IMPORTANT
          // apparently smart table does not monitor changes to st-safe-src unless
          // there is an insertion/deletion of rows or complete reassignment
          // since in this case, updateStats is just modifying the values of existing
          // rows, we need to explicitly call the stPipe function to trigger the sort/filter
          // Had we reassigned vm.currentTargets everytime we call getTargets, this
          // refreshTargets would have not been necessary
          $scope.$broadcast('refreshTargets');
        })
        .catch(function(error) {
          vm.isLoading = false;
          $log.getInstance('TargetsDashboardController').info('Error', error);
        });
    }

    function _loadUserSettings() {
      return userSettingsService.getUserSettings()
        .then(function (userSettings) {
          vm.userSettings = userSettings;
          vm.columns = columnsFetchService.getColumnList(userSettings, vm.defaultColumns, 'dashboardTargets');
        });
    }

    // When the DOM element is removed from the page,
    // AngularJS will trigger the $destroy event on
    // the scope. This gives us a chance to cancel any
    // pending timer that we may have.
    $scope.$on(
      '$destroy',
      function () {
        $interval.cancel(timer);
      }
    );
  }
})();
